// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconBrandChrome,
  IconHelp,
  IconSitemap,
  IconUsers,
  IconBarbell,
  IconMan,
  IconJumpRope,
  IconUserCircle,
  IconMapPin,
  IconQrcode,
  IconLanguage,
  IconPhoto,
  IconGauge,
  IconTrophy,
  IconRobot,
  IconAlertTriangle,
} from "@tabler/icons";

// constant
const icons = {
  IconBrandChrome,
  IconHelp,
  IconSitemap,
  IconUsers,
  IconBarbell,
  IconMan,
  IconJumpRope,
  IconUserCircle,
  IconMapPin,
  IconQrcode,
  IconLanguage,
  IconPhoto,
  IconGauge,
  IconTrophy,
  IconRobot,
  IconAlertTriangle,
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
  id: "sample-docs-roadmap",
  type: "group",
  children: [
    {
      id: "admins",
      title: <FormattedMessage id="Admins" />,
      type: "item",
      url: "/admins",
      icon: icons.IconUsers,
      breadcrumbs: false,
    },

    {
      id: "users",
      title: <FormattedMessage id="Users" />,
      type: "item",
      url: "/users",
      icon: icons.IconUserCircle,
      breadcrumbs: false,
    },

    {
      id: "gyms",
      title: <FormattedMessage id="Gyms" />,
      type: "item",
      url: "/gyms",
      icon: icons.IconUserCircle,
      breadcrumbs: false,
    },

    {
      id: "specialists",
      title: <FormattedMessage id="Specialist" />,
      type: "item",
      url: "/specialists",
      icon: icons.IconUserCircle,
      breadcrumbs: false,
    },

    {
      id: "equipmentType",
      title: <FormattedMessage id="Equipment Type" />,
      type: "item",
      url: "/equipment-type",
      icon: icons.IconBarbell,
      breadcrumbs: false,
    },
    {
      id: "bodyparts",
      title: <FormattedMessage id="Bodyparts" />,
      type: "item",
      url: "/bodyparts",
      icon: icons.IconMan,
      breadcrumbs: false,
    },
    {
      id: "exercisetags",
      title: <FormattedMessage id="ExerciseTag" />,
      type: "item",
      url: "/exercise-tags",
      icon: icons.IconMan,
      breadcrumbs: false,
    },
    {
      id: "locations",
      title: <FormattedMessage id="Location" />,
      type: "item",
      url: "/locations",
      icon: icons.IconMapPin,
      breadcrumbs: false,
    },

    // {
    //     id: 'qrcodes',
    //     title: <FormattedMessage id="QRCodes" />,
    //     type: 'item',
    //     url: '/qrcodes',
    //     icon: icons.IconQrcode,
    //     breadcrumbs: false
    // },

    {
      id: "equipments",
      title: <FormattedMessage id="Equipments" />,
      type: "item",
      url: "/equipments",
      icon: icons.IconBarbell,
      breadcrumbs: false,
    },
    {
      id: "exercises",
      title: <FormattedMessage id="Exercises" />,
      type: "item",
      url: "/exercise",
      icon: icons.IconJumpRope,
      breadcrumbs: false,
    },

    {
      id: "workout",
      title: <FormattedMessage id="Workouts" />,
      type: "item",
      url: "/workout",
      icon: icons.IconJumpRope,
      breadcrumbs: false,
    },
    {
      id: "nutrition",
      title: <FormattedMessage id="Nutrition" />,
      type: "item",
      url: "/nutrition",
      icon: icons.IconBrandChrome,
      breadcrumbs: false,
    },
    {
      id: "workouttags",
      title: <FormattedMessage id="Workout Tags" />,
      type: "item",
      url: "/workout-tags",
      icon: icons.IconMan,
      breadcrumbs: false,
    },
    
    {
      id: "collections",
      title: <FormattedMessage id="Collections" />,
      type: "item",
      url: "/collections",
      icon: icons.IconJumpRope,
      breadcrumbs: false,
    },
    {
      id: "caching",
      title: "Caching",
      type: "item",
      url: "/caching",
      icon: icons.IconSitemap,
      breadcrumbs: false,
    },
    {
      id: "performance",
      title: "Performance",
      type: "item",
      url: "/performance",
      icon: icons.IconGauge,
      breadcrumbs: false,
    },
    {
      id: "scores",
      title: "Scores",
      type: "item",
      url: "/scores",
      icon: icons.IconTrophy,
      breadcrumbs: false,
    },
    {
      id: "ai-config",
      title: "Coachy AI Config",
      type: "item",
      url: "/ai-config",
      icon: icons.IconRobot,
      breadcrumbs: false,
    },
    {
      id: "coachy-errors",
      title: "Coachy Errors",
      type: "item",
      url: "/coachy-errors",
      icon: icons.IconAlertTriangle,
      breadcrumbs: false,
    },
    {
      id: "labels",
      title: "Translations",
      type: "item",
      url: "/labels",
      icon: icons.IconLanguage,
      breadcrumbs: false,
    },
    {
      id: "covers",
      title: "Covers",
      type: "item",
      url: "/covers",
      icon: icons.IconPhoto,
      breadcrumbs: false,
    },
  ],
};

export default other;
